<template>
  <div v-if="video_id" class="video-demo">
    <div v-if="inline" class="video-demo--inline">
      <iframe
        :src="src"
        width="100%"
        height="400px"
        frameborder="0"
        allowfullscreen
        sandbox="allow-scripts allow-same-origin"
      />
    </div>

    <div v-if="!inline">
      <button :class="button_class" @click="toggle">
        <slot>
          <i class="fa fa-video-camera" />
          &nbsp; Watch Demo
        </slot>
      </button>

      <div :class="{ 'is-active': active }" class="modal">
        <div class="modal-background" @click="toggle" />
        <div class="modal-content is-half">
          <iframe
            :src="src"
            width="100%"
            style="height: 520px;"
            frameborder="0"
            allowfullscreen
            sandbox="allow-scripts allow-same-origin"
          />
        </div>
        <button class="modal-close is-large" @click="toggle" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DemoVideo',

  props: {
    inline: { default: false, type: Boolean },
    video_id: { required: true, type: Number },
    button_text: { type: String, default: 'Watch Demo' },
    button_class: { type: String, default: 'button is-outlined' }
  },

  data() {
    return {
      active: false
    };
  },

  computed: {
    src() {
      return this.active || this.inline
        ? `https://player.vimeo.com/video/${this.video_id}`
        : '';
    }
  },

  methods: {
    toggle() {
      this.active = !this.active;
    }
  }
};
</script>
